import { status, json } from '../controllers/Fetch';
import { getBaseUrl, getSessionTicket } from '../config';
import { ContentType } from '../interfaces';

export function getCastById(id: string) {
  return fetch(getBaseUrl() + '/EPG/JSON/GetCastDetail', {
    method: 'POST',
    headers: { SessionTicket: getSessionTicket() },
    body: JSON.stringify({
      castIds: [id],
    }),
  })
    .then(status)
    .then((r) => json(r as Response));
}

export async function getCastByName(castName: string) {
  return fetch(getBaseUrl() + '/EPG/JSON/Search', {
    method: 'POST',
    headers: { SessionTicket: getSessionTicket() },
    body: JSON.stringify({
      key: castName,
      contenttype: ContentType.VOD,
      type: 1016,
      count: -1,
      offset: 0,
    }),
  })
    .then(status)
    .then((r) => json(r as Response));
}
